export interface IMembersStore {
  currentMember?: any;
  members: any[];
}

export const membersStore = {
  members: [],
};
